/* eslint-disable @typescript-eslint/ban-types */
import moment, { Moment } from 'moment-timezone'

import getColor from '~/lib/getColor'
import { SecondaryProcess } from '~/redux-modules/quote-qllt/types'
import { CostAndLeadTime_quote_quoteModels_items_selectedQuoteModelRevision_processesDetails_postProcesses as CostAndLeadTimeQuotePostProcess } from '~/redux-modules/quote-qllt/__generated__/CostAndLeadTime'
export const applyColor = (
    needByDate: Moment | null,
    isTargetDateNotMet: boolean,
    isFreightShipping?: boolean,
    isNeedRfq?: boolean,
) => {
    if (
        needByDate &&
        !isFreightShipping &&
        moment(needByDate).isBefore(moment(), 'D')
    ) {
        return getColor('error')
    } else if (isTargetDateNotMet) {
        if (isFreightShipping && !isNeedRfq) {
            return getColor('warning6')
        } else if (!isNeedRfq) {
            return getColor('warning6')
        } else {
            return ''
        }
    } else {
        return ''
    }
}

export const getMessage = (
    needByDate: Moment | null,
    isTargetDateNotMet: boolean,
    isNeedRfq: boolean | undefined,
    isFreightShipping?: boolean,
) => {
    if (needByDate && moment(needByDate).isBefore(moment(), 'D')) {
        return "Invalid date as it's in the past"
    } else if (isTargetDateNotMet) {
        if (isFreightShipping && !isNeedRfq) {
            return 'Cannot calculate if this date can be met due to unknown lead time of freight shipping'
        } else if (!isNeedRfq) {
            return 'Some parts exceed this date'
        } else {
            return ''
        }
    } else {
        return ''
    }
}

export const getOrderLateBy = ({
    needByDate,
    deliveredByDate,
}: {
    needByDate: string
    deliveredByDate: string
}) => {
    const deliveredByDateUTC = moment
        .utc(deliveredByDate)
        .local()
        .format('YYYY-MM-DD')
    const needByDateUTC = moment.utc(needByDate).local().format('YYYY-MM-DD')

    const lateness = moment(deliveredByDateUTC).diff(
        moment(needByDateUTC),
        'days',
    )

    return lateness
}

export const formatPostProcess = (
    process: CostAndLeadTimeQuotePostProcess,
): SecondaryProcess => ({
    processId: process.postProcess.id,
    processColorId: process.postProcessColor?.id || null,
    processInspectionCriteria: process?.postProcessInspectionCriteria,
    processNumParts: process?.postProcessNumParts,
    processThicknessInInches: process.postProcessThickness?.value || null,
    info: process,
})
export const formatSecondaryProcesses = (
    postProcesses: CostAndLeadTimeQuotePostProcess[],
): SecondaryProcess[] => postProcesses.map(formatPostProcess) || []
